import MyAssetsView from "../../features/assets/MyAssetsView";

const MyAssetsPage = () => <MyAssetsView />;

export default MyAssetsPage;
